<template>
  <div :class="['nav-buttons', customClass, { 'nav-buttons-fixed': isFixed }]">
    <div v-if="showPrev" class="nav-button prev-button" @click="handlePrev">
      {{ prevText || $t('commonBut.p000002') }}
    </div>
    <div
      v-if="showNext"
      class="nav-button next-button"
      :class="{ 'disabled': disabled }"
      @click="handleNext"
    >
      {{ nextText || $t('commonBut.p000001') }}
    </div>
  </div>
</template>

<script>

/**
 * 导航按钮组件
 * @component navButtons
 * @description 用于移动端场景的双按钮导航组件，支持自定义样式、跳转和事件触发
 * @example
 * <nav-buttons
 *   prevText="返回"
 *   nextText="提交"
 *   prevUrl="/previous"
 *   customClass="customClass"
 *   :isFixed="false"
 *   :disabled="false"
 *   @on-prev="handlePrev"
 *   @on-next="handleSubmit"
 * />
 */
export default {
  name: "NavButtons",
  props: {
    // 左侧按钮文案
    prevText: {
      type: String,
      default: ''
    },
    // 右侧按钮文案
    nextText: {
      type: String,
      default: ''
    },
    // 左侧按钮跳转链接，如果不传则触发 on-prev 事件
    prevUrl: {
      type: String,
      default: ""
    },
    // 右侧按钮跳转链接，如果不传则触发 on-next 事件
    nextUrl: {
      type: String,
      default: ""
    },
    customClass: {
      type: String,
      default: ""
    },
    // 是否显示左侧按钮
    showPrev: {
      type: Boolean,
      default: true
    },
    // 是否显示右侧按钮
    showNext: {
      type: Boolean,
      default: true
    },
    // 路由跳转方式
    navigationType: {
      type: String,
      default: "back",
      validator: function(value) {
        return ["push", "replace", "back"].indexOf(value) !== -1;
      }
    },
    // 是否固定在底部
    isFixed: {
      type: Boolean,
      default: true
    },
    // 下一步按钮是否禁用
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    /**
     * 处理左侧按钮点击
     * 如果设置了 prevUrl 则进行路由跳转，否则触发 on-prev 事件
     */
    handlePrev() {
      if (this.prevUrl) {
        this.handleNavigation(this.prevUrl);
      } else {
        if (this.navigationType == 'back') {
          this.handleNavigation(this.prevUrl);
        } else {
          this.$emit("on-prev");
        }
      }
    },

    /**
     * 处理右侧按钮点击
     * 如果设置了 nextUrl 则进行路由跳转，否则触发 on-next 事件
     */
    handleNext() {
      if (this.nextUrl) {
        this.handleNavigation(this.nextUrl);
      } else {
        this.$emit("on-next");
      }
    },

    /**
     * 处理路由导航
     * @param {string} url 跳转地址
     */
    handleNavigation(url) {
      switch (this.navigationType) {
        case "push":
          this.$router.push(url);
          break;
        case "replace":
          this.$router.replace(url);
          break;
        case "back":
          this.$router.back();
          break;
      }
    }
  }
};
</script>

<style lang="less" scoped>

// 按钮容器样式
.nav-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  // height: 176px;
  padding: 20px 72px 58px;
  box-sizing: border-box;
  // 吸底样式
  &.nav-buttons-fixed {
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    box-sizing: border-box;
    z-index: 100;
  }
  // 按钮基础样式
  .nav-button {
    text-align: center;
    flex: 1;
    height: 104px;
    line-height: 104px;
    background: rgba(23, 22, 28, 0.04);
    border-radius: 200px;
    font-size: 32px;
    &.prev-button {
      margin-right: 32px;
      color: #17161c;
      font-weight: 500;
    }
    &.next-button {
      background: #17161c;
      color: white;
      font-weight: 500;
      &.disabled {
        background: #747377;
        color: rgba(255,255,255,0.35);
      }
    }
  }
}

.black-theme{
  .nav-buttons{
    background: #1B1C24;
    .nav-button{
      background: #8E92A3;
      color: #fff;
      &.next-button{
        background: #377CFB;
      }
      &.disabled {
        opacity: 0.4;
      }
    }
  }
}

</style>
